import React from "react";
import { useNavigate } from "react-router-dom";
// import Setting from "../Svgs/Setting";
import "./styles.css";

const HeadingForAll = (props) => {
  const navigate = useNavigate();
  
  return (
    <div 
      className="bg-[#10c9c0] flex justify-center relative"
      style={{
        maxHeight: '35vh', // Limit to 35% of viewport height like original
        minHeight: 'fit-content'
      }}
    >
      {props.isProfile && (
        <button
          onClick={() => navigate("/profile-settings")}
          className="absolute right-2 bottom-2"
        >
          {/* <div className="w-10 h-10 stroke-white">
            <Setting />
          </div> */}
        </button>
      )}
      <div 
        className="md:ml-[3rem] ml-[1.5rem] mr-[1.5rem] text-white w-full max-w-[1440px] flex flex-col justify-center"
        style={{
          paddingTop: 'clamp(0.5rem, 2vmin, 1rem)',
          paddingBottom: 'clamp(1rem, 3vmin, 2.5rem)'
        }}
      >
        {/* Small heading with responsive sizing */}
        <h2 
          className="m-0 font-bold" // Fixed font weight
          style={{
            fontSize: 'clamp(12px, 2.5vmin, 24px)', // Responds to both width and height
            paddingTop: 'clamp(0.25rem, 1vmin, 0.5rem)'
          }}
        >
          {props.smallHeading}
        </h2>
        
        {/* Big heading with responsive sizing */}
        <h1 
          className="m-0 font-bold" // Fixed font weight
          style={{
            fontSize: 'clamp(24px, 8vmin, 72px)', // Responds to both width and height
            lineHeight: 'clamp(28px, 9vmin, 78px)', // Proportional line height
            paddingTop: 'clamp(0.25rem, 1vmin, 0.5rem)',
            paddingBottom: 'clamp(0.25rem, 1vmin, 0.5rem)'
          }}
        >
          {props.bigHeading}
        </h1>
      </div>
    </div>
  );
};

export default HeadingForAll;